import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSummary: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSummary"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 5V16.5H17.25V14.25L21.25 17.25L17.25 20.25V18H3V5H4.5ZM7.5 6.5H17.5V8H7.5V6.5ZM7.5 11.5H14V13H7.5V11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSummary;
